import {Injectable, NgZone} from '@angular/core';
import {Store} from '@ngrx/store';
import {authLogout} from '@spout/web-global/actions';
import {PartialAuthAccountStates} from '@spout/web-global/models';
import {Observable, Observer} from 'rxjs';
import {SptFirestoreService} from '../firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthLogoutWatchService {
  constructor(
    private sptFirebase: SptFirestoreService,
    private store: Store<PartialAuthAccountStates>,
    private zone: NgZone
  ) {}

  logoutFirebase$() {
    return new Observable((observer: Observer<any>) => {
      this.sptFirebase.auth
        .signOut()
        .then(() => {
          observer.next(true);
        })
        .catch((error: any) => {
          observer.error(error);
        })
        .finally(() => {
          observer.complete();
        });
    });
  }

  logoutOnBrowserClose() {
    const that = this;
    window.onbeforeunload = () => {
      // This does not do anything, just feels right to
      // put it here.
      //
      that.zone.run(() => {
        that.store.dispatch(authLogout());
      });

      this.sptFirebase.auth.signOut().then(() => {
        /* noop */
      });
    };
  }
}
